import { useDebounce } from './useDebounce';
import {
    useGetSearchedDeviceOrGroupQuery,
    useGetSearchedGatewayOrGroupQuery,
} from '../features/deviceManagement/deviceApi';
import { isNullOrUndefined } from '../utils/helpers';

type ReturnProps = {
    isLoading: boolean;
    currentData: any;
};

export const useSearchDeviceOrGroup = ({ searchKey }: { searchKey: any }): ReturnProps => {
    const [, debouncedValue] = useDebounce(undefined, 1000, searchKey);

    const { currentData, isLoading, isFetching, isError } = useGetSearchedDeviceOrGroupQuery(
        { searchKey: debouncedValue },
        {
            skip: isNullOrUndefined(debouncedValue) || isNullOrUndefined(searchKey),
            refetchOnMountOrArgChange: true,
        }
    );
    return { currentData: !isError ? currentData?.data?.records : [], isLoading: isLoading || isFetching };
};

export const useSearchGatewayOrGroup = ({ search }: { search: any }): ReturnProps => {
    const [, debouncedValue] = useDebounce(undefined, 1000, search);

    const { data, isLoading, isFetching } = useGetSearchedGatewayOrGroupQuery(
        { search: search },
        {
            skip: isNullOrUndefined(debouncedValue) || isNullOrUndefined(search),
            refetchOnMountOrArgChange: true,
        }
    );
    return { currentData: data?.data, isLoading: isLoading || isFetching };
};
